import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';

const TooltipContext = createContext(null);

export function TooltipProvider({ children }) {
  const [showAllOpen, setShowAllOpen] = useState(false);

  const toggleShowAll = useCallback(() => {
    setShowAllOpen((prev) => !prev);
  }, []);

  const resetShowAll = useCallback(() => {
    setShowAllOpen(false);
  }, []);

  // 단축키 n: 모든 툴팁 동시 표시 토글 (input/textarea/select 포커스 시 제외)
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key !== 'n' && e.key !== 'N') return;
      const tag = document.activeElement?.tagName?.toLowerCase();
      if (['input', 'textarea', 'select'].includes(tag)) return;
      setShowAllOpen((prev) => !prev);
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, []);

  return (
    <TooltipContext.Provider value={{ showAllOpen, toggleShowAll, resetShowAll }}>
      {children}
    </TooltipContext.Provider>
  );
}

export function useTooltip() {
  const ctx = useContext(TooltipContext);
  return ctx || { showAllOpen: false, toggleShowAll: () => {}, resetShowAll: () => {} };
}
